import { mobileRegex } from 'consts';

declare const window: IOperaWindow;

export interface DataLayerEvent {
  blikErrorCode?: string;
  cardDataStatus?: string;
  event: string;
  paymentCallbackStatus?: string;
  selectedPaymentMethodId?: string;
}

interface IOperaWindow extends Window {
  opera: string;
  dataLayer: DataLayerEvent[];
}

const splitAmount = (value: number) => {
  const amount = `${value}`;

  const integers = +amount.substr(0, amount.length - 2);
  const decimalNumber: number = +amount.substr(amount.length - 2, amount.length);

  const decimals = decimalNumber < 10 ? `0${decimalNumber}` : `${decimalNumber}`;

  return { integers, decimals };
};

export const isBlank = (str?: string): boolean => !str || /^\s*$/.test(str);

const mobileAndTabletCheck = () => {
  let check = false;
  if (window.screen.width >= 1024) return false;
  ((val: string) => {
    if (mobileRegex.mobile.test(val) || mobileRegex.tablet.test(val.substr(0, 4))) {
      check = true;
    }
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

const getContainerHeight = (ref: HTMLDivElement | null) => {
  if (!ref) return 0;

  const { marginTop, marginBottom } = window.getComputedStyle(ref);
  const margin = (parseFloat(marginTop as string) || 0) + (parseFloat(marginBottom as string) || 0);
  return ref.offsetHeight + margin;
};

const msieversion = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');

  return msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);
};

/* language without region code */
const trimLanguageTag = (languageTag: string) => (languageTag ? languageTag.split(/[-_]/)[0] : '');

/**
 * Loading additional script to component
 * @param url
 * @returns {Promise} - promise is returned
 */
const loadScript = url =>
  new Promise<void>((resolve, reject) => {
    try {
      let script = document.querySelector(`script[src="${url}"]`) as HTMLScriptElement;
      script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      document.body.appendChild(script);
      script.onload = () => {
        resolve();
      };
      script.onerror = () => {
        reject();
      };
    } catch (e) {
      reject(e);
    }
  });

export { getContainerHeight, splitAmount, mobileAndTabletCheck, msieversion, trimLanguageTag, loadScript };
